import type { ProfileSectionDropdownProps } from "./ProfileSectionDropdown";
import { ProfileSectionDropdown } from "./ProfileSectionDropdown";

export interface ProfileSectionUserMenuProps
  extends ProfileSectionDropdownProps {}

export const ProfileSectionUserMenu = ({
  headline = "",
  imageUrl = "",
  name = "",
  onEditProfileClick,
  onSignOutClick,
  publicUid = "",
  showMemberBilling = false,
  canAccessAuthenticationPage = false,
  canShowPaywallsAffiliate = false,
}: ProfileSectionUserMenuProps) => (
  <ProfileSectionDropdown
    imageUrl={imageUrl}
    headline={headline}
    name={name}
    onEditProfileClick={onEditProfileClick}
    onSignOutClick={onSignOutClick}
    publicUid={publicUid}
    showMemberBilling={showMemberBilling}
    canAccessAuthenticationPage={canAccessAuthenticationPage}
    canShowPaywallsAffiliate={canShowPaywallsAffiliate}
  />
);
